"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CELL_STYLE_SUBHEADER = exports.CELL_STYLE_FOOTER = exports.CELL_FORMAT_TIMESTAMP_UTC = exports.CELL_FORMAT_TIMESTAMP = exports.CELL_FORMAT_PERCENT_CHANGE = exports.CELL_FORMAT_PERCENT = exports.CELL_FORMAT_NUMBER = exports.CELL_FORMAT_MONEY_CHANGE = exports.CELL_FORMAT_MONEY = exports.CELL_FORMAT_DATESTAMP = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _semanticUiReact = require("semantic-ui-react");

var _react = _interopRequireWildcard(require("react"));

var _DateTimeUtils = require("@omniex/onx-common-js/lib/utils/DateTimeUtils");

var _NumberUtils = require("@omniex/onx-common-js/lib/utils/NumberUtils");

var _ObjectUtils = require("@omniex/onx-common-js/lib/utils/ObjectUtils");

var _LangUtils = require("@omniex/onx-common-js/lib/utils/LangUtils");

var _FunctionUtils = require("@omniex/onx-common-js/lib/utils/FunctionUtils");

var _colors = _interopRequireDefault(require("../../colors"));

function displayInHomeCurrency(v, symbol) {
  if (['EUR', 'JPY', 'USD'].includes(symbol)) return "".concat(getFiatSymbol(symbol)).concat(v);else if (symbol === 'CHF') return "CHF ".concat(v);else return symbol ? "".concat(v, " ").concat(symbol) : "".concat(v);
}

;

var getFiatSymbol = function getFiatSymbol(s) {
  return {
    EUR: '€',
    JPY: '¥',
    USD: '$'
  }[s] || s;
};

function getTextColor(value) {
  if (value > 0) return _colors.default.green;
  if (value < 0) return _colors.default.red;
  return 'inherit';
}

var CELL_FORMAT_DATESTAMP = 'datestamp';
exports.CELL_FORMAT_DATESTAMP = CELL_FORMAT_DATESTAMP;
var CELL_FORMAT_MONEY = 'money';
exports.CELL_FORMAT_MONEY = CELL_FORMAT_MONEY;
var CELL_FORMAT_MONEY_CHANGE = 'money change';
exports.CELL_FORMAT_MONEY_CHANGE = CELL_FORMAT_MONEY_CHANGE;
var CELL_FORMAT_NUMBER = 'number';
exports.CELL_FORMAT_NUMBER = CELL_FORMAT_NUMBER;
var CELL_FORMAT_PERCENT = 'percent';
exports.CELL_FORMAT_PERCENT = CELL_FORMAT_PERCENT;
var CELL_FORMAT_PERCENT_CHANGE = 'percent change';
exports.CELL_FORMAT_PERCENT_CHANGE = CELL_FORMAT_PERCENT_CHANGE;
var CELL_FORMAT_TIMESTAMP = 'timestamp';
exports.CELL_FORMAT_TIMESTAMP = CELL_FORMAT_TIMESTAMP;
var CELL_FORMAT_TIMESTAMP_UTC = 'timestamp UTC';
exports.CELL_FORMAT_TIMESTAMP_UTC = CELL_FORMAT_TIMESTAMP_UTC;
var CELL_STYLE_FOOTER = 'footer';
exports.CELL_STYLE_FOOTER = CELL_STYLE_FOOTER;
var CELL_STYLE_SUBHEADER = 'subheader';
exports.CELL_STYLE_SUBHEADER = CELL_STYLE_SUBHEADER;

var Table = function (_PureComponent) {
  (0, _inherits2.default)(Table, _PureComponent);

  function Table() {
    (0, _classCallCheck2.default)(this, Table);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Table).apply(this, arguments));
  }

  (0, _createClass2.default)(Table, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_semanticUiReact.Table, (0, _extends2.default)({}, this.props, {
        basic: "very",
        compact: "very",
        singleLine: true,
        size: "small",
        unstackable: true
      }));
    }
  }]);
  return Table;
}(_react.PureComponent);

exports.default = Table;
(0, _defineProperty2.default)(Table, "Header", _semanticUiReact.Table.Header);
(0, _defineProperty2.default)(Table, "HeaderCell", function TableHeaderCell(props) {
  var helperProps = ['border', 'textAlign', 'formatType,', 'styleName'];
  var style = {
    borderBottom: props.border || "3px solid ".concat(_colors.default.internalBorderColor),
    fontSize: '.9em',
    paddingBottom: 5,
    textAlign: props.textAlign || 'left',
    verticalAlign: 'bottom',
    whiteSpace: 'normal'
  };
  props = (0, _ObjectUtils.omit)(props, helperProps);
  return _react.default.createElement(_semanticUiReact.Table.HeaderCell, (0, _extends2.default)({}, props, {
    style: style
  }), props.children);
});
(0, _defineProperty2.default)(Table, "Cell", function TableCell(props) {
  var helperProps = ['border', 'color', 'fontSize', 'fontWeight', 'formatType', 'ifNotNumber', 'padding', 'paddingLeft', 'styleName'];
  var value = props.children;
  var style;
  var defaultStyle = {
    borderTop: props.border || '',
    color: props.color,
    fontSize: props.fontSize,
    fontWeight: props.fontWeight
  };
  var format = props.format;

  if (props.styleName === CELL_STYLE_SUBHEADER) {
    style = {
      backgroundColor: _colors.default.transparentBlack,
      borderTop: props.border || "3px solid ".concat(_colors.default.internalBorderColor),
      fontWeight: 'bold',
      paddingLeft: 5
    };
  } else if (props.styleName === CELL_STYLE_FOOTER) {
    style = (0, _objectSpread2.default)({}, defaultStyle, {
      borderTop: "3px solid ".concat(_colors.default.internalBorderColor),
      padding: props.padding
    });
    props = (0, _objectSpread2.default)({}, props, {
      textAlign: props.textAlign || 'right'
    });
  } else {
    style = defaultStyle;
  }

  var ifNotNumber = props.ifNotNumber || 'N/A';

  if (props.formatType === CELL_FORMAT_NUMBER) {
    props = (0, _objectSpread2.default)({}, props, {
      textAlign: 'right'
    });
    value = Number.isFinite(value) ? (0, _NumberUtils.format)(value, format || '0[.]00') : ifNotNumber;
  }

  if (props.formatType === CELL_FORMAT_MONEY) {
    style = (0, _objectSpread2.default)({}, style, {
      color: props.isProfitLoss && Number.isFinite(value) ? value < 0 ? _colors.default.red : value > 0 ? _colors.default.green : 'inherit' : 'inherit'
    });
    props = (0, _objectSpread2.default)({}, props, {
      textAlign: 'right'
    });

    if (Number.isFinite(value)) {
      value = (0, _NumberUtils.format)(value, format || '0,0.00');
      var homeCurrencySymbol = (0, _ObjectUtils.get)(props, 'homecurrency.symbol');
      value = displayInHomeCurrency(value, homeCurrencySymbol);
    } else {
      value = ifNotNumber;
    }
  }

  if (props.formatType === CELL_FORMAT_MONEY_CHANGE) {
    style = (0, _objectSpread2.default)({}, style, {
      color: Number.isFinite(value) && value < 0 ? _colors.default.red : value > 0 ? _colors.default.green : 'inherit'
    });
    props = (0, _objectSpread2.default)({}, props, {
      textAlign: 'right'
    });
    value = Number.isFinite(value) ? (0, _NumberUtils.format)(value, format ? "$".concat(format) : '$0,0.00') : ifNotNumber;
  }

  if (props.formatType === CELL_FORMAT_PERCENT) {
    props = (0, _objectSpread2.default)({}, props, {
      textAlign: 'right'
    });
    value = (0, _NumberUtils.format)(value, '0.0%');
  }

  if (props.formatType === CELL_FORMAT_PERCENT_CHANGE) {
    style = (0, _objectSpread2.default)({}, style, {
      color: getTextColor(value)
    });
    props = (0, _objectSpread2.default)({}, props, {
      textAlign: 'right'
    });
    var percentFormat = "".concat(value !== 0 ? '+' : '', "0.0%");
    value = (0, _NumberUtils.format)(value, percentFormat);
  }

  if (props.formatType === CELL_FORMAT_TIMESTAMP) {
    value = (0, _DateTimeUtils.format)(value, null, format || 'YYYY-MM-DD HH:mm Z');
  }

  if (props.formatType === CELL_FORMAT_TIMESTAMP_UTC) {
    value = (0, _DateTimeUtils.formatUtc)(value, null, format || 'YYYY-MM-DD HH:mm') + ' UTC';
  }

  if (props.formatType === CELL_FORMAT_DATESTAMP) {
    value = !(0, _LangUtils.isNil)(value) ? (0, _DateTimeUtils.format)(value, null, format || 'YYYY-MM-DD') : ifNotNumber;
  }

  if (!props.formatType && !props.styleName) {
    style = (0, _objectSpread2.default)({}, style, {
      padding: props.padding,
      paddingLeft: props.paddingLeft || {}
    });
  }

  props = (0, _ObjectUtils.omit)(props, helperProps);
  return _react.default.createElement(_semanticUiReact.Table.Cell, (0, _extends2.default)({}, props, {
    style: style
  }), value);
});
(0, _defineProperty2.default)(Table, "Body", _semanticUiReact.Table.Body);
(0, _defineProperty2.default)(Table, "Row", function TableRow(_ref) {
  var onClick = _ref.onClick,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["onClick"]);
  var style = {
    cursor: onClick ? 'pointer' : ''
  };
  return _react.default.createElement(_semanticUiReact.Table.Row, (0, _extends2.default)({}, rest, {
    style: style,
    onClick: (0, _LangUtils.isFunction)(onClick) ? onClick : _FunctionUtils.noop
  }));
});
(0, _defineProperty2.default)(Table, "Footer", _semanticUiReact.Table.Footer);